import { render, staticRenderFns } from "./OfficialVisit.vue?vue&type=template&id=c213cb66"
import script from "./OfficialVisit.vue?vue&type=script&lang=js"
export * from "./OfficialVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports